//Install
import React, { Component } from "react";
//Install
import YI834W from "../../../../Media/Image/000.png";

//Element
class Logo extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("a", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB kg269a", href: "/" },
            //Element
            React.createElement("img", { alt: "Temas", title: "Temas", src: YI834W, width: "110", height: "auto" })
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Logo;